/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is w/v different from w/w and v/v?`)
};

const es_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿En qué se diferencia p/v de p/p y v/v?`)
};

const de_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie unterscheidet sich w/v von w/w und v/v?`)
};

const nl_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen g/v, g/g en v/v?`)
};

const fr_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En quoi le p/v diffère-t-il du p/p et du v/v ?`)
};

const it_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cosa differisce p/v da p/p e v/v?`)
};

const pt_br2_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença entre p/v, p/p e v/v?`)
};

const pt_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que difere m/v de m/m e v/v?`)
};

const ja_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/vはw/wやv/vとどう違いますか？`)
};

const zh_pctsol_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`w/v 与 w/w、v/v 有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pctsol_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pctsol_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pctsol_faq_q2", locale)
	if (locale === "en") return en_pctsol_faq_q2(inputs)
	if (locale === "es") return es_pctsol_faq_q2(inputs)
	if (locale === "de") return de_pctsol_faq_q2(inputs)
	if (locale === "nl") return nl_pctsol_faq_q2(inputs)
	if (locale === "fr") return fr_pctsol_faq_q2(inputs)
	if (locale === "it") return it_pctsol_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_pctsol_faq_q2(inputs)
	if (locale === "pt") return pt_pctsol_faq_q2(inputs)
	if (locale === "ja") return ja_pctsol_faq_q2(inputs)
	return zh_pctsol_faq_q2(inputs)
};